import { ApolloClient, InMemoryCache } from '@apollo/client'
import { HttpLink } from 'apollo-link-http'
import config from '../config'
import { ApolloProvider } from '@apollo/client'
import { setContext } from '@apollo/client/link/context';
const {api} = config
const API_URL  = api



const ApolloClientProvider = ({token, children}) => {

    const link = new HttpLink({uri: API_URL+"/graphql"})
    // console.log("client token:", token)
    const setAuthLink= setContext( (request, prevContext) => ({
        headers: {
          ...prevContext.headers,
          'Authorization': "Bearer " + token
        }
    }))

    const client = new ApolloClient({
        link: setAuthLink.concat(link),
        cache: new InMemoryCache()
    })

    return (
        <ApolloProvider client = {client}>
            {children}
        </ApolloProvider>
    )
}

export default ApolloClientProvider